"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AsyncEither_1 = require("../lib/AsyncEither");
const Either_1 = require("../lib/Either");
const errorGenerator = (message) => (error) => ({
    code: 500,
    message,
    error,
});
const getToken = (fetchFunction) => AsyncEither_1.asyncRight(fetchFunction(`/api/token`, {
    credentials: 'include',
    headers: {
        accept: 'application/json',
    },
}), errorGenerator('Could not get token')).flatMap(resp => resp.json());
exports.default = (fetchFunction) => (values) => {
    let mutatedUrl = values.url;
    for (const key of values.paramKeys) {
        const match = mutatedUrl.match(new RegExp(`/:${key}\\??(/|$)`, 'g'));
        if (!match || match.length !== 1) {
            throw new Error(`Invalid key in URL ${values.method.toUpperCase()} ${values.url}: ${key}`);
        }
        mutatedUrl = mutatedUrl.replace(new RegExp(`:${key}\\??`), '');
    }
    if (mutatedUrl.includes(':')) {
        const regex = /:(.*?)(\/|$)/g;
        const unusedKeys = [];
        let m;
        while ((m = regex.exec(mutatedUrl)) !== null) {
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            unusedKeys.push(m[1]);
        }
        throw new Error(`Keys remaining in URL ${values.method.toUpperCase()} ${values.url}: '${unusedKeys.join("', '")}'`);
    }
    const urlReplacer = (url) => (params) => {
        let newURL = url;
        for (const param in params) {
            if (params.hasOwnProperty(param)) {
                newURL = newURL.replace(new RegExp(`:${param}\\??`), params[param]);
            }
        }
        newURL = newURL.replace(/:\w*\?/g, '');
        return newURL;
    };
    const customURLReplacer = urlReplacer(values.url);
    return (params, body) => (values.needsToken
        ? getToken(fetchFunction)
        : AsyncEither_1.asyncRight(undefined, errorGenerator('Could not get token')))
        .map(token => values.method.toUpperCase() === 'GET'
        ? {}
        : token
            ? {
                headers: {
                    'content-type': 'application/json',
                    'accept': 'application/json',
                },
                body: JSON.stringify({
                    ...(body || {}),
                    token,
                }),
                method: values.method,
            }
            : !!body
                ? {
                    headers: {
                        'content-type': 'application/json',
                        'accept': 'application/json',
                    },
                    body: JSON.stringify(body),
                    method: values.method,
                }
                : {})
        .map(request => ({
        ...request,
        credentials: 'include',
    }))
        .map(request => fetchFunction(customURLReplacer(params), request), errorGenerator('Could not complete request'))
        .flatMap(response => response.status === 204
        ? Either_1.Either.right(void 0)
        : response.json.apply(response));
};
//# sourceMappingURL=defaultAPICallBase.js.map